.speedbump {
	display: flex;
	align-items: center;
	justify-content: center;
	position: fixed;
	width: 100vw;
	height: 100vh;
	z-index: 100;
	top: 0;
	left: 0;
	animation: speedbumpIn 250ms linear forwards;

	&__overlay {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.7);
	}

	&__inner {
		position: absolute;
		width: 90%;
		max-width: 750px;
		background: #fff;
		padding: 30px;
	}
	.js-close-speedbump {
		position: absolute;
		top: 8px;
		right: 8px;

		&:hover, &:focus { opacity: .6; }
		svg {
			@include svg-format(20px, 20px, #222);
			stroke: #222;
		}
	}
	&__headline {
		color: $primary;
		margin: 0 0 24px 0;
	}
	&__actions {
		display: flex;
		align-items: center;

		a {
		margin-right: 20px;
		
		svg { @include svg-format(14px, 14px, currentColor); }
		&.arrow-link {
			position: relative;
			color: $primary;
			text-decoration: none;
			font-weight: 700;
			
			&.white-link {
			color: white !important;
			}
			svg {
			@include svg-format(14px, 14px, currentColor);
			transition: transform .3s ease-in-out;
			}
			&::after {
			content: '';
			background: currentColor;
			height: 1px;
			width: 0px;
			position: absolute;
			top: 100%;
			left: 0;
			transition: width .3s ease-in-out;
			}
			&:hover, &:focus {
			outline: none;
			color: $link-hover-primary;
		
			&:after { width: 100%; }
			svg { transform: translateX(4px); }
			}
		}
		}
	}
}


@include media-breakpoint-down(md) {
	.speedbump {

		&__actions {
			flex-direction: column;

			a + a { margin-top: 24px; }
		}
	}
}



@include media-breakpoint-down(sm) {
	.speedbump {

		&__actions {
			flex-direction: column;

			.btn.btn-primary { min-width: 80%; }			
		}
	}
}



@keyframes speedbumpIn {
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
}
